import { render, staticRenderFns } from "./PickingOrderReview.vue?vue&type=template&id=323e0be5"
import script from "./PickingOrderReview.vue?vue&type=script&lang=js"
export * from "./PickingOrderReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports